import { getEkeyUserData } from './request.get-user-identity.e-key.js';
import { getUnicUserData } from './request.get-user-identity.unic.js';

async function getUserIdentityRequest(userId, loginProvider) {
  switch (loginProvider) {
    case "UNIC":
      return getUnicUserData(userId);
    case "EKEY":
      return getEkeyUserData(userId);
    default:
      return {
        id: userId,
        name: userId,
        role: "teacher",
        authenticationProvider: "ip"
      };
  }
}

export { getUserIdentityRequest };
//# sourceMappingURL=request.get-user-identity.js.map
